import LoLExamination from './LoLExamination';

export default LoLExamination;
